import React from 'react';

const logos = [
  { src: '/images/python.png', alt: 'Python logo' },
  { src: '/images/nodejs.png', alt: 'Node.js logo' },
  { src: '/images/react.png', alt: 'React logo' },
  { src: '/images/cp.png', alt: 'cPanel logo' },
  { src: '/images/nginx.png', alt: 'Nginx logo' },
  { src: '/images/apache.png', alt: 'Apache logo' },
  { src: '/images/wp.png', alt: 'WordPress logo' },
  { src: '/images/linux.png', alt: 'Linux logo' }
];

export default function TickerCarousel() {
  const duplicated = [...logos, ...logos];
  return (
    <div className="ticker-wrapper py-12">
      <div className="ticker-track">
        {duplicated.map((logo, i) => (
          <div key={i} className="ticker-item">
            <img
              src={logo.src}
              alt={logo.alt}
              className="object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
